import { DashboardVariation } from '@/types/graphql';

export const ENABLED_CONTAINERS_BY_VARIATION_STORAGE_KEY = 'enabledContainersByVariation';
export const NORTH_STAR_PREFS_RESET_FLAG = 'enabledContainersByVariation.northStarResetV1';

// One-shot, per-browser reset of the user's stored NORTH_STAR enabled-container
// preferences. Without this, existing users (whose stored array of enabled keys
// no longer intersects the current container keys) would land on an empty
// dashboard instead of falling back to defaultEnabled containers — see the
// `?? getDefaultEnabledContainerKeys` fallback in DashboardPageContext.tsx,
// which only fires when the variation has *no* entry at all.
//
// Idempotent: writes a flag after running so subsequent loads (including ones
// that happen after the user has set new preferences) leave the data alone.
export const runNorthStarPreferenceReset = (storage: Storage = window.localStorage): void => {
    if (storage.getItem(NORTH_STAR_PREFS_RESET_FLAG)) {
        return;
    }

    try {
        const raw = storage.getItem(ENABLED_CONTAINERS_BY_VARIATION_STORAGE_KEY);
        if (raw) {
            const parsed: unknown = JSON.parse(raw);
            if (parsed && typeof parsed === 'object' && DashboardVariation.NORTH_STAR in parsed) {
                const next = Object.fromEntries(
                    Object.entries(parsed as Record<string, unknown>).filter(
                        ([key]) => key !== DashboardVariation.NORTH_STAR,
                    ),
                );
                storage.setItem(ENABLED_CONTAINERS_BY_VARIATION_STORAGE_KEY, JSON.stringify(next));
            }
        }
    } catch {
        // Corrupt JSON — leave the stored value alone. The atom's Zod
        // validator will overwrite it with {} on first read.
    }

    storage.setItem(NORTH_STAR_PREFS_RESET_FLAG, '1');
};
